import $ from 'jquery';

/** @param {HTMLInputElement} input */
function ZipCode(input) {
    input.addEventListener('change', onInputChange);
}

function onInputChange(event) {
    /** @type {HTMLInputElement} */
    const input = event.currentTarget;
    const {value: ID} = input;

    if (!ID)
        return;

    const {
        api: url,
        target: targetIdRef
    } = input.dataset;
    /** @type {HTMLInputElement} */
    const target = document.getElementById(targetIdRef);
    /** @type {XMLHttpRequest} */
    const xhr = $.get(url, {ID}).done(({data: value}) => target.value = value);

    input.addEventListener('change', function abortRequest() {
        xhr.abort;
        input.removeEventListener('change', abortRequest);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.zip-code');

    elements.forEach(ZipCode);
});

export default ZipCode;
